import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

<link
href="https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,600italic,300italic,400italic,300,700italic,800italic,800"
rel="stylesheet"></link>

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js